module.exports = __webpack_public_path__ + "a768e7de/img/revit-icon.5ff0d581.svg";